import { useContext, useState } from 'react';
import { Load } from '../../../Load';
import InputMask from 'react-input-mask';
import { Button, Card } from 'react-bootstrap';
import './style.css'
import AlertMessage from '../../../Alert';
import { useNavigate } from 'react-router-dom';
import api from '../../../../services/api';
import { CadastroContext } from '../../../../contexts/CadastroContext';

const AsoVerificarCadastroEmpresa = () => {
    const { cadastro, handleCadastroChange } = useContext(CadastroContext);
    const [isLoading, setIsLoading] = useState(false);
    const [cnpj, setCnpj] = useState('');
    const [alert, setAlert] = useState({ show: false, message: "", variant: "success" });
    const [disabled, setDisabled] = useState(true);
    const navigate = useNavigate();

    const handleCnpjChange = (event: any) => {
        const value = event.target.value.toUpperCase();
        if (value.replace(/[\.\-\/\s]/g, '').length < 14) {
            setDisabled(true);
            return;
        }
        if (value && validarCNPJ(value.toString())) {
            setCnpj(value);
            cadastro.reaproveitamentoAso = true;
            cadastro.isEmpresa = true;
            handleCadastroChange(cadastro);
            setDisabled(false);
        }
    }

    const handleContinuar = async () => {
        try {
            setIsLoading(true);
            const response = await api.get(`verificaCnpjCadastrado/${encodeURIComponent(cnpj)}`);
            if (!response.data) {
                setIsLoading(false);
                setAlert({ show: true, message: "CNPJ não encontrado", variant: "danger" });
                return;
            }
            return navigate('/');
        } catch (error) {
            setDisabled(true);
            setIsLoading(false);
            setAlert({ show: true, message: "CNPJ não encontrado", variant: "danger" });
        }
    }

    const handleCadastreseChange = () => {
        cadastro.reaproveitamentoAso = true;
        cadastro.isEmpresa = true;
        handleCadastroChange(cadastro);
        return navigate('/aso/registro/validar-info-empresa');
    }

    const cnpjCharValue = (char: string): number => char.toUpperCase().charCodeAt(0) - 48;

    const validarCNPJ = (cnpj: string): boolean => {
        cnpj = cnpj.replace(/[\.\-\/\s]/g, '').toUpperCase();

        if (cnpj.length !== 14) return false;
        if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj)) return false;
        if (/^(.)\1+$/.test(cnpj)) return false;

        // Calcula o primeiro dígito verificador
        let tamanho: number = cnpj.length - 2;
        let numeros: string = cnpj.substring(0, tamanho);
        let digitos: string = cnpj.substring(tamanho);
        let soma: number = 0;
        let pos: number = tamanho - 7;

        for (let i: number = tamanho; i >= 1; i--) {
            soma += cnpjCharValue(numeros.charAt(tamanho - i)) * pos--;
            if (pos < 2) pos = 9;
        }
        let resultado: number = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado !== parseInt(digitos.charAt(0))) return false;

        // Calcula o segundo dígito verificador
        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;

        for (let i: number = tamanho; i >= 1; i--) {
            soma += cnpjCharValue(numeros.charAt(tamanho - i)) * pos--;
            if (pos < 2) pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado !== parseInt(digitos.charAt(1))) return false;

        return true;
    };    

    return (
        <>
            <Load isLoading={isLoading} />
            <div className='cad-emp-aso-container-cnpj'>
                <div className='cad-emp-aso-titulo-container-cnpj'>
                    <div className="cad-emp-aso-titulo-cnpj">Qual é o número de CNPJ do usuário?</div>
                </div>
                <div className='cad-emp-aso-container-card-cnpj'>
                <Card className='cad-emp-aso-card-cnpj'>
                    <div className='cad-emp-aso-card-content-container-cnpj'>
                        <div className='cad-emp-aso-card-content-cnpj'>
                            <label htmlFor="cnpj-input" className='label-container'>
                                <span className='cad-emp-aso-card-content-cnpj-label-span'>Número</span>
                            </label>
                            <div className='cad-emp-aso-card-content-container-cnpj-input'>
                            <span className='cad-emp-aso-card-content-cnpj-input-prefix'>CNPJ</span>
                            <InputMask
                                mask="**.***.***/****-99"
                                type="text"
                                pattern="[A-Za-z0-9]*"
                                id='cnpj-input'
                                title='Digite um CNPJ'
                                minLength={14}
                                className='cad-emp-aso-card-content-cnpj-input'
                                style={{ textTransform: 'uppercase' }}
                                onChange={handleCnpjChange} />
                            </div>
                            <div className='cad-emp-aso-card-content-cnpj-input-span'>
                                <span>Insira apenas números, sem traços nem pontos.</span>
                            </div>
                        </div>
                    </div>
                </Card>
                    <div className='cad-emp-aso-button-cnpj-container'>
                        <Button
                            variant="primary"
                            className='cad-emp-aso-button-cnpj-content'
                            onClick={handleCadastreseChange}>
                            Cadastre-se
                            </Button>
                            <Button
                            variant="primary"
                            className='cad-emp-aso-button-cnpj-content'
                            disabled={disabled}
                            onClick={handleContinuar}>
                            Continuar
                        </Button>
                    </div>
                </div>
            </div>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </>
    );  
}

export default AsoVerificarCadastroEmpresa;